import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f2a262ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-col md:flex-row flex items-center md:space-between p-4\" data-v-f2a262ea><div class=\"header flex flex-1 mb-4 md:mb-0 text-center md:text-left\" data-v-f2a262ea></div><div class=\"font-heebo flex-col text-center flex justify-center mt-0 px-2 md:px-0 flex-none\" data-v-f2a262ea></div><div class=\"flex flex-1 flex-row justify-end\" data-v-f2a262ea><a href=\"https://www.scirt.eu/\" target=\"_blank\" data-v-f2a262ea><img src=\"img/scirt/scirtlogoforwebsite-1.png\" class=\"h-10\" data-v-f2a262ea></a></div></div>", 1)
const _hoisted_2 = { class: "flex-grow flex-col sm:grid grid-cols-1 md:grid-cols-12 gap-4" }
const _hoisted_3 = { class: "sm:col-span-3 flex flex-col items-center sm:items-start" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "pb-8 pt-4 text-md mt-8 col-span-8" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "mt-8 text-center sm:text-left" }
const _hoisted_8 = ["value", "placeholder"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:pt-8 pl-8 flex-col items-center flex" }, null, -1))
const _hoisted_10 = { class: "flex flex-col sm:flex-row mt-auto" }
const _hoisted_11 = { class: "flex flex-row flex-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "img/eu.logo.png",
  alt: "EU Flag",
  class: "h-12 align-top mr-2 w-auto"
}, null, -1))
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "flex-1 sm:ml-2 text-center sm:text-right mt-4 sm:mt-0" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "flex flex-col sm:flex-row items-end sm:items-start" }
const _hoisted_17 = { class: "flex flex-row items-center justify-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_country_flag = _resolveComponent("country-flag")!
  const _component_vue_select = _resolveComponent("vue-select")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.wrapperClasses])
  }, [
    _hoisted_1,
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.config.image1,
              class: "w-3/4 sm:w-full"
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", {
              class: "mt-4",
              innerHTML: _ctx.$t(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_6),
            _withDirectives(_createElementVNode("p", _hoisted_7, null, 512), [
              [_directive_t, _ctx.config.textPart3]
            ]),
            _createElementVNode("input", {
              type: "text",
              value: _ctx.state.nickname.value,
              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.setNickname($event.target.value))),
              placeholder: _ctx.$t(_ctx.config.placeholderNickname),
              class: "mt-4 border border-gray-300 p-2 rounded-lg w-full sm:w-auto"
            }, null, 40, _hoisted_8),
            _createVNode(_component_ActionButton, {
              text: "buttons.start",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.next())),
              class: "mt-8 mx-auto sm:mx-0 block"
            })
          ]),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("p", {
              innerHTML: _ctx.$t('eu-footer'),
              class: "text-gray-800 text-xxs"
            }, null, 8, _hoisted_13)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("p", {
              class: "text-sm",
              innerHTML: _ctx.$t(_ctx.config.textPart4)
            }, null, 8, _hoisted_15)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_vue_select, {
              options: _ctx.$root.$i18n.availableLocales,
              "model-value": _ctx.$root.$i18n.locale,
              "open-direction": "top",
              onSelected: _ctx.selectLocale,
              class: "locale-options ml-2"
            }, {
              "dropdown-item": _withCtx(({option}) => [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_country_flag, {
                    country: _ctx.localeCountries[option],
                    size: "normal",
                    class: "no-margin-flag"
                  }, null, 8, ["country"]),
                  _createTextVNode("   " + _toDisplayString(_ctx.locales[option] || option), 1)
                ])
              ]),
              label: _withCtx((options) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options, (option) => {
                  return (_openBlock(), _createBlock(_component_country_flag, {
                    key: option,
                    country: _ctx.localeCountries[option],
                    size: "normal",
                    class: "no-margin-flag"
                  }, null, 8, ["country"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["options", "model-value", "onSelected"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}